import { render, staticRenderFns } from "./scheduleTeacherViewer.vue?vue&type=template&id=36c2cfb9&scoped=true&"
import script from "./scheduleTeacherViewer.vue?vue&type=script&lang=js&"
export * from "./scheduleTeacherViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c2cfb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
